
import Vue from 'vue';

export const serverBus = new Vue();
